import { DescriptionPage_MarketingSource as MarketingSource } from '__generated__/graphql-types';

import routeConfig from 'bundles/unified-description-page-common/constants/routeConfig';
import getXDPPageLink from 'bundles/unified-description-page-common/utils/getXDPPageLink';

function getCourseLink({
  courseSlug,
  specializationSlug,
  programSlug,
  orgSlug,
  marketingSource,
  localizedLanguageRegionCode,
}: {
  courseSlug: string;
  specializationSlug?: string;
  programSlug?: string;
  orgSlug?: string;
  marketingSource?: MarketingSource;
  localizedLanguageRegionCode?: string;
}): string {
  let path;
  if (orgSlug && !marketingSource) {
    path = `/organizations/${orgSlug}`;
  } else if (programSlug && !marketingSource) {
    path = `/programs/${programSlug}`;
  }

  if (marketingSource === MarketingSource.Google) {
    path = `${path ?? ''}/${routeConfig.GOOGLE_COURSES.pathname}/${courseSlug}`;
  } else {
    path = `${path ?? ''}/${routeConfig.COURSE.pathname}/${courseSlug}`;
  }

  if (specializationSlug && marketingSource === MarketingSource.PaidMedia) {
    path = `${path}/paidmedia?specialization=${specializationSlug}`;
  } else if (specializationSlug) {
    path = `${path}?specialization=${specializationSlug}`;
  }

  return getXDPPageLink({ productPageUrlPath: path, subfolderLocaleCode: localizedLanguageRegionCode });
}
export default getCourseLink;
